export default [
  {
    id: 1,
    question: "Javascript is an _______ language",
    options: ["Object-Oriented", "Object-Based", "Procedural"],
  },
  {
    id: 2,
    question:
      "Following methods can be used to display data in some form using Javascript",
    options: ["document.write()", "console.log()", "window.alert()"],
  },
  {
    id: 3,
    question:
      "When an operator value is NULL, the typeof returned by the unary operator is:",
    options: ["Boolean", "Undefined", "Object"],
  },
  {
    id: 4,
    question: "What does the toString() method return?",
    options: ["Return Object", "Return String", "Return Integer"],
  },
  {
    id: 5,
    question:
      "Which function is used to serialize an object into a JSON string?",
    options: ["stringify()", "parse()", "convert()"],
  },
  {
    id: 6,
    question: "How do you pass data to components from outside in React?",
    options: ["setState", "PropTypes", "props"],
  },
  {
    id: 7,
    question: "A state in React.js is also known as?",
    options: [
      "internal storage of component",
      "external storage of component",
      "permanent storage",
    ],
  },
  {
    id: 8,
    question: "In MVC, what does React.js act as?",
    options: ["Model", "Controller", "Router"],
  },
];

export const answers = [0, 1, 2, 1, 0, 2, 0, 1, 2, 0];
